import {Component} from '@angular/core';

@Component({
    selector: 'app-payments',
    templateUrl: './payments.component.html',
    standalone: false
})
export class PaymentsComponent {

}
